export enum SharedDialogType {
    Info,
    Continue,
    Confirmation
}
